import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const windowTypes = [
  {
    icon: 'ri-home-4-line',
    title: 'Réparation Fenêtres PVC',
    description: 'Spécialistes de la réparation de fenêtres PVC. Remplacement de joints, réglage de mécanismes, changement de vitrage et réparation de systèmes d\'ouverture.',
    features: [
      'Remplacement de joints d\'étanchéité',
      'Réglage des charnières et paumelles',
      'Changement de vitrage simple ou double',
      'Réparation des mécanismes d\'ouverture'
    ],
    image: 'https://public.readdy.ai/ai/img_res/fe02d22e0c8e18109986c1ad6de2a9c4.jpg',
    color: 'teal',
    link: '/bordeaux'
  },
  {
    icon: 'ri-plant-line',
    title: 'Réparation Fenêtres Bois',
    description: 'Experts en réparation de fenêtres bois. Traitement du bois, remplacement de parties abîmées, rénovation complète et entretien pour prolonger la durée de vie.',
    features: [
      'Traitement et protection du bois',
      'Remplacement de parties endommagées',
      'Rénovation et ponçage',
      'Changement de quincaillerie'
    ],
    image: 'https://readdy.ai/api/search-image?query=elegant%20wooden%20window%20repair%20in%20classic%20French%20home%20craftsman%20restoring%20natural%20wood%20frame%20with%20professional%20tools%20warm%20interior%20simple%20clean%20background%20traditional%20carpentry%20work%20quality%20restoration&width=700&height=600&seq=wood-window-repair-002&orientation=landscape',
    color: 'orange',
    link: '/bordeaux'
  },
  {
    icon: 'ri-building-line',
    title: 'Réparation Fenêtres Aluminium',
    description: 'Professionnels de la réparation de fenêtres aluminium. Réparation de cadres, remplacement de vitrage, ajustement de mécanismes et entretien des finitions.',
    features: [
      'Réparation de cadres aluminium',
      'Remplacement de vitrage isolant',
      'Ajustement des systèmes coulissants',
      'Entretien des finitions et joints'
    ],
    image: 'https://readdy.ai/api/search-image?query=sleek%20aluminum%20window%20repair%20in%20modern%20building%20professional%20technician%20working%20on%20grey%20metal%20frame%20contemporary%20architecture%20simple%20clean%20background%20industrial%20quality%20precision%20work&width=700&height=600&seq=alu-window-repair-003&orientation=landscape',
    color: 'gray',
    link: '/bordeaux'
  }
];

export function WindowTypes() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="inline-block bg-orange/10 text-orange px-6 py-2 rounded-full text-sm font-semibold mb-6">
            NOS SPÉCIALITÉS
          </div>
          <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
            Réparation par Type<br />
            de Fenêtre
          </h2>
        </motion.div>

        <div className="space-y-16">
          {windowTypes.map((type, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: index * 0.2 }}
              className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-12 items-center bg-gradient-to-br ${
                type.color === 'teal' ? 'from-teal/5 to-teal/10' :
                type.color === 'orange' ? 'from-orange/5 to-orange/10' :
                'from-gray-100 to-gray-200'
              } rounded-[32px] p-12 shadow-lg hover:shadow-2xl transition-all duration-500`}
            >
              <div className="flex-1">
                <div className="w-20 h-20 flex items-center justify-center mb-8">
                  <i className={`${type.icon} text-7xl ${
                    type.color === 'teal' ? 'text-teal' :
                    type.color === 'orange' ? 'text-orange' :
                    'text-gray-700'
                  }`}></i>
                </div>
                <h3 className="text-4xl font-bold text-gray-900 mb-6">
                  <Link to={type.link} className="hover:text-teal transition-colors">
                    {type.title}
                  </Link>
                </h3>
                <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                  {type.description}
                </p>
                <ul className="space-y-4">
                  {type.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <div className={`w-6 h-6 flex items-center justify-center rounded-full ${
                        type.color === 'teal' ? 'bg-teal/20' :
                        type.color === 'orange' ? 'bg-orange/20' :
                        'bg-gray-300'
                      } flex-shrink-0 mt-1`}>
                        <i className={`ri-check-line text-lg ${
                          type.color === 'teal' ? 'text-teal' :
                          type.color === 'orange' ? 'text-orange' :
                          'text-gray-700'
                        }`}></i>
                      </div>
                      <span className="text-gray-700 text-base leading-relaxed">{feature}</span>
                    </li>
                  ))}
                </ul>
                <Link to={type.link}>
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className={`mt-8 px-8 py-4 ${
                      type.color === 'teal' ? 'bg-teal hover:bg-teal-dark' :
                      type.color === 'orange' ? 'bg-orange hover:bg-orange-dark' :
                      'bg-gray-800 hover:bg-gray-900'
                    } text-white rounded-full font-semibold text-base shadow-lg hover:shadow-xl transition-all duration-300 whitespace-nowrap cursor-pointer`}
                  >
                    Demander un Devis
                  </motion.button>
                </Link>
              </div>

              <div className="flex-1 w-full">
                <Link to={type.link}>
                  <motion.div
                    whileHover={{ scale: 1.03 }}
                    transition={{ duration: 0.3 }}
                    className="relative rounded-[24px] overflow-hidden shadow-2xl cursor-pointer"
                  >
                    <div className="w-full h-96">
                      <img
                        src={type.image}
                        alt={type.title}
                        title={type.title}
                        className="w-full h-full object-cover object-top"
                        loading="lazy"
                      />
                    </div>
                    <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent"></div>
                  </motion.div>
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}